@if (dashboardView; as view) {
  <div class="mx-auto flex min-h-0 w-full max-w-desktop flex-col gap-6">

    <section class="primary-card overflow-hidden p-4 sm:p-6">
      <div class="flex items-center gap-4">
        <div
          class="flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-primary/10 text-xl font-semibold text-primary shadow-md sm:size-20">
          <span>{{ userInitials() }}</span>
        </div>
        <div class="min-w-0">
          <h1 class="truncate text-xl font-semibold text-neutral-grey-950 sm:text-2xl">
            Welkom {{ userDisplayName() }}
          </h1>
        </div>
      </div>
    </section>

    <!-- Hidden on the manager dashboard for now.
    @if (view === 'team') {
      <div class="grid min-h-0 gap-4 sm:grid-cols-2 xl:grid-cols-4">

        <div class="stacked-card gap-3 p-4 sm:p-5">
          <div class="flex items-start justify-between gap-2">
            <p class="text-2xl font-bold tabular-nums text-neutral-grey-950">{{ teamCount() ?? '—' }}</p>
            <div class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <ion-icon name="people-outline" class="size-5"></ion-icon>
            </div>
          </div>
          <p class="text-sm text-neutral-grey-600">Teamleden</p>
        </div>

        <div class="stacked-card gap-3 p-4 sm:p-5">
          <div class="flex items-start justify-between gap-2">
            <div>
              <p
                class="text-2xl font-bold tabular-nums text-neutral-grey-950">{{ popStatusSummary()?.completed ?? '—' }}
                actief/afgerond</p>
              <p class="text-xs text-neutral-grey-500">{{ popStatusSummary()?.open ?? '—' }} nog open</p>
            </div>
            <div class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-success-50 text-success-700">
              <ion-icon name="document-text-outline" class="size-5"></ion-icon>
            </div>
          </div>
          <p class="text-sm text-neutral-grey-600">POP ingevuld</p>
        </div>

        <div class="stacked-card gap-3 p-4 sm:p-5">
          <div class="flex items-start justify-between gap-2">
            <div>
              <p class="text-2xl font-bold tabular-nums text-neutral-grey-950">{{ pmStatusSummary()?.completed ?? '—' }}
                actief/afgerond</p>
              <p class="text-xs text-neutral-grey-500">{{ pmStatusSummary()?.open ?? '—' }} nog open</p>
            </div>
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-attention-50 text-attention-700">
              <ion-icon name="clipboard-outline" class="size-5"></ion-icon>
            </div>
          </div>
          <p class="text-sm text-neutral-grey-600">PM ingevuld</p>
        </div>

        <div class="stacked-card gap-3 p-4 sm:p-5">
          <div class="flex items-start justify-between gap-2">
            <div>
              <p
                class="text-2xl font-bold tabular-nums text-neutral-grey-950">{{ assessmentStatusSummary()?.completed ?? '—' }}
                /{{ assessmentStatusSummary()?.totalEmployees ?? '—' }}</p>
              <p class="text-xs text-neutral-grey-500">{{ assessmentStatusSummary()?.open ?? '—' }} nog open</p>
            </div>
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
              <ion-icon name="ribbon-outline" class="size-5"></ion-icon>
            </div>
          </div>
          <p class="text-sm text-neutral-grey-600">Assessments afgerond</p>
        </div>

      </div>
    }
    -->

    <div class="flex min-h-0 flex-col gap-6">
      <div class="flex min-h-0 flex-col gap-6">
        <section class="flex flex-col gap-4">
          <div>
            <h2 class="text-lg font-semibold text-neutral-grey-950">Snelkoppelingen</h2>
            <p class="text-sm text-neutral-grey-700">Direct naar de onderdelen die je het meest gebruikt.</p>
          </div>

          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            @if (view === 'team') {

              @if (meetingRoute()) {
                <a [routerLink]="meetingRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="chatbubbles-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Mijn Afspraken</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Open je agenda voor afspraken en
                        feedbackmomenten.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="chatbubbles-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Mijn Afspraken</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Open je agenda voor afspraken en
                        feedbackmomenten.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (assessmentsRoute()) {
                <a [routerLink]="assessmentsRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="ribbon-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Assessments beheren</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Bekijk en beheer assessments en resultaten.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="ribbon-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Assessments beheren</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Bekijk en beheer assessments en resultaten.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (teamRoute()) {
                <a [routerLink]="teamRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="people-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Medewerkers beheren</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Naar het overzicht van medewerkers.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="people-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Medewerkers beheren</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Naar het overzicht van medewerkers.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (careersRoute()) {
                <a [routerLink]="careersRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="trail-sign-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Carriérepad</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Naar totaaloverzicht van het carriérepad.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="trail-sign-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Carriérepad</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Naar totaaloverzicht van het carriérepad.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                <div class="flex items-start gap-3">
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
                    <ion-icon name="library-outline" class="size-5"></ion-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-neutral-grey-700">Kennisbank</h3>
                    <p class="mt-1 text-sm text-neutral-grey-600">Nog niet beschikbaar</p>
                  </div>
                  <ion-icon name="lock-closed-outline"
                            class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                </div>
              </div>

              <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                <div class="flex items-start gap-3">
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
                    <ion-icon name="school-outline" class="size-5"></ion-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-neutral-grey-700">Leermiddelen</h3>
                    <p class="mt-1 text-sm text-neutral-grey-600">Nog niet beschikbaar</p>
                  </div>
                  <ion-icon name="lock-closed-outline"
                            class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                </div>
              </div>

            } @else {

              @if (myDevelopmentRoute()) {
                <a [routerLink]="myDevelopmentRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="document-text-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Persoonlijke ontwikkeling</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Bekijk je plannen, doelen en gespreksverslagen.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="document-text-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Persoonlijke ontwikkeling</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Bekijk je plannen, doelen en gespreksverslagen.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (meetingRoute()) {
                <a [routerLink]="meetingRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="chatbubbles-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Afspraken</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Open je agenda voor afspraken en
                        feedbackmomenten.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="chatbubbles-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Afspraken</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Open je agenda voor afspraken en
                        feedbackmomenten.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (careersRoute()) {
                <a [routerLink]="careersRoute()"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="trail-sign-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Carrierepad</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Naar totaaloverzicht van het carrierepad.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="trail-sign-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Carrierepad</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Naar totaaloverzicht van het carrierepad.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              @if (myDevelopmentRoute()) {
                <a [routerLink]="myDevelopmentRoute()" [queryParams]="{tab: UserPerformanceTab.ASSESSMENT_OVERVIEW}"
                   class="surface-default hover-effect-elevate flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="ribbon-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-950">Assessments invullen</h3>
                      <p class="mt-1 text-sm text-neutral-grey-700">Bekijk je assessments en resultaten.</p>
                    </div>
                    <ion-icon name="open-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-500"></ion-icon>
                  </div>
                </a>
              } @else {
                <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                      <ion-icon name="ribbon-outline" class="size-5"></ion-icon>
                    </div>
                    <div class="min-w-0 flex-1">
                      <h3 class="text-sm font-semibold text-neutral-grey-700">Assessments invullen</h3>
                      <p class="mt-1 text-sm text-neutral-grey-600">Bekijk je assessments en resultaten.</p>
                    </div>
                    <ion-icon name="lock-closed-outline"
                              class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                  </div>
                </div>
              }

              <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                <div class="flex items-start gap-3">
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
                    <ion-icon name="lock-closed-outline" class="size-5"></ion-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-neutral-grey-700">Skillspaspoort</h3>
                    <p class="mt-1 text-sm text-neutral-grey-600">Nog niet beschikbaar</p>
                  </div>
                  <ion-icon name="lock-closed-outline"
                            class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                </div>
              </div>

              <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                <div class="flex items-start gap-3">
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
                    <ion-icon name="library-outline" class="size-5"></ion-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-neutral-grey-700">Leermiddelen</h3>
                    <p class="mt-1 text-sm text-neutral-grey-600">Nog niet beschikbaar</p>
                  </div>
                  <ion-icon name="lock-closed-outline"
                            class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                </div>
              </div>

              <div class="surface-secondary-subtle flex flex-col gap-3 rounded-xl p-4 sm:p-5">
                <div class="flex items-start gap-3">
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-neutral-grey-100 text-neutral-grey-500">
                    <ion-icon name="school-outline" class="size-5"></ion-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-neutral-grey-700">Kennisbank</h3>
                    <p class="mt-1 text-sm text-neutral-grey-600">Nog niet beschikbaar</p>
                  </div>
                  <ion-icon name="lock-closed-outline"
                            class="mt-0.5 size-4 shrink-0 text-neutral-grey-400"></ion-icon>
                </div>
              </div>

            }
          </div>
        </section>

        @if (view === 'team') {
          <app-user-performance-selector></app-user-performance-selector>
        }

        <section class="primary-card min-h-0 overflow-hidden">
          <app-planner-calendar [currentUserId]="currentUserId()"></app-planner-calendar>
        </section>
      </div>

      @if (view === 'personal') {
        <aside class="min-h-0 self-start">
          <app-notifications-overview class="block w-full"></app-notifications-overview>
        </aside>
      }
    </div>

  </div>
} @else {
  <div class="grid h-full w-full place-items-center">
    <div class="card-shadow-default aspect-square w-full max-w-md rounded-3xl outline-1 outline-black/5">
      <div class="grid h-full place-content-center place-items-center px-6 text-center">
        <ion-icon name="build-outline" class="size-8 text-neutral-grey-700"></ion-icon>
        <h3 class="mt-4 text-base font-semibold text-neutral-grey-950">Dashboard in ontwikkeling</h3>
        <p class="mt-1 text-sm text-neutral-grey-700">Binnenkort vind je hier je inzichten en overzichten.</p>
      </div>
    </div>
  </div>
}
